import React from "react";
import { Heading } from "./shared/Heading/Heading";
import { SubDomainForm } from "./shared/SubDomainForm/SubDomainForm";
import { SubDomainEditor } from "./shared/SubDomainEditor/SubDomainEditor";
import { ExistingSubDomains } from "./ExistingSubDomains/ExistingSubDomains";
import { useGetCustomDomainsQuery } from "../../../../api/customDomain/queries/useGetCustomDomainsQuery";
import { useAddCustomDomainMutation } from "../../../../api/customDomain/mutations/useAddCustomDomainMutation";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../services/UINotificationService";
import { useGetCustomDomainUseStatusQuery } from "../../../../api/customDomain/queries/useGetCustomDomainUseStatusQuery";
import { useChangeConnectStatusMutation } from "../../../../api/customDomain/mutations/useChangeConnectStatusMutation";
import { useQueryParamsState } from "../../../../utilities/hooks/useQueryParamsState";
import { extractApiError } from "../../../../utilities/api";
import Loader from "../../../Common/Loader";

export function CustomDomain({ getUrlList }) {
  const { tSmartConfig } = useAppTranslation.SmartConfig();
  const { data: domainsData, isLoading: isGetDomainsLoading } =
    useGetCustomDomainsQuery({
      onError: () => {
        uiNotification.error(
          tSmartConfig("patientPortal.customDomain.error.getSubdomains"),
        );
      },
    });

  const {
    mutateAsync: changeConnectionStatus,
    isLoading: isChangeConnectionLoading,
  } = useChangeConnectStatusMutation({
    onSuccess: () => {
      getUrlList();
    },
    onError: () => {
      uiNotification.error(
        tSmartConfig("patientPortal.customDomain.error.connect"),
      );
    },
  });

  const { data: domainStatus } = useGetCustomDomainUseStatusQuery({
    onError: () => {
      uiNotification.error(
        tSmartConfig("patientPortal.customDomain.error.connectStatus"),
      );
    },
  });

  const isConnected = Boolean(domainStatus?.customDomainStatus);

  const [currentSubDomainEdit, setCurrentSubDomainEdit] = useQueryParamsState({
    subdomain: "",
  });

  const { mutateAsync, isLoading: inAddLoading } = useAddCustomDomainMutation({
    onSuccess: (response) => {
      setCurrentSubDomainEdit({ subdomain: response.id });
    },
    onError: (error) => {
      const message = extractApiError(error);
      uiNotification.error(
        tSmartConfig([
          `patientPortal.customDomain.error.${message}`,
          "patientPortal.customDomain.error.failed_to_add_custom_domain",
        ]),
      );
    },
  });

  const onChangeConnectionStatus = () => {
    changeConnectionStatus({
      isConnected: isConnected,
    });
  };

  return (
    <div className="appointment-content">
      <Loader showLoader={isChangeConnectionLoading} />
      <Heading
        isConected={isConnected}
        changeConnection={onChangeConnectionStatus}
        isLoading={isChangeConnectionLoading}
      />
      {isConnected && !currentSubDomainEdit.subdomain && (
        <SubDomainForm onAddDomain={mutateAsync} isLoading={inAddLoading} />
      )}
      {isConnected && currentSubDomainEdit.subdomain && (
        <SubDomainEditor
          domainId={currentSubDomainEdit.subdomain}
          getUrlList={() => getUrlList()}
          onClose={() => setCurrentSubDomainEdit({ subdomain: "" })}
        />
      )}
      {Boolean(domainsData?.length) &&
        isConnected &&
        !currentSubDomainEdit.subdomain &&
        !isGetDomainsLoading && (
          <ExistingSubDomains
            domainsList={domainsData}
            setSubdomain={setCurrentSubDomainEdit}
          />
        )}
    </div>
  );
}
